import { selectScreenSize } from 'store/slice/screen';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container, FullScreenSheet, SheetHeader, SideSheet, Stack } from '@drone-js/core';
import { closeOverlay, showOverlay, OverlayType, selectInfoOverlayVisible } from 'store/slice/overlay';
import { DisplaySectionName, FooterVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { DetailPageDisplayConfig } from 'component/page/detail/DetailPageModularize/contentRegistry.type';
import { VerticalContentsHandler } from 'component/page/detail/DetailPageModularize/ContentsHandler/VerticalContentsHandler';
import { selectCmsFromBootstrap, selectPrerenderStateFromBootstrap } from 'store/slice/bootstrap';
import FooterComponent from 'component/page/detail/DetailPageModularize/ContentsHandler/FooterComponent';
import { FULL_SCREEN_SHEET_ELEMENT_NAME, SIDE_SHEET_ELEMENT_NAME } from 'core-framework/constant/DetailPageModularConstant';

interface Props {
    config: DetailPageDisplayConfig[DisplaySectionName.InfoOverlay];
}

const MOBILE_PADDING = '16';
const DESKTOP_PADDING = '24';

export const InfoOverlayContents: React.FC<Props> = (props) => {
    const screenSize = useSelector(selectScreenSize);
    const isPrerender = useSelector(selectPrerenderStateFromBootstrap);
    const isInfoOverlayVisible = useSelector(selectInfoOverlayVisible);
    const cms = useSelector(selectCmsFromBootstrap);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (isPrerender) {
            dispatch(showOverlay(OverlayType.InfoOverlay));
        }
    }, [isPrerender, dispatch]);

    const onClose = () => {
        dispatch(closeOverlay(OverlayType.InfoOverlay));
    };

    if (props.config.contents.length === 0) {
        return null;
    }

    if (screenSize.desktop) {
        return (
            <SideSheet
                visible={isInfoOverlayVisible}
                data-testid={SIDE_SHEET_ELEMENT_NAME}
                data-element-name={SIDE_SHEET_ELEMENT_NAME}
                onClose={onClose}
                size="l"
                header={<SheetHeader title="" closeButton={{ 'aria-label': cms[126815] }} divider={false} />}
            >
                <Container ps={DESKTOP_PADDING} pe={DESKTOP_PADDING}>
                    <VerticalContentsHandler contents={props.config.contents} />
                </Container>
            </SideSheet>
        );
    }

    return (
        <>
            <FullScreenSheet
                visible={isInfoOverlayVisible}
                data-testid={FULL_SCREEN_SHEET_ELEMENT_NAME}
                data-element-name={FULL_SCREEN_SHEET_ELEMENT_NAME}
                onClose={onClose}
                zIndex={99}
            >
                <Container pb="64" px={MOBILE_PADDING}>
                    <Stack direction="column">
                        <Stack direction="row" justifyContent="flex-end">
                            <Button size="s" hierarchy="tertiary" leadingIcon="fill.symbol.close" variant="icon" aria-label={cms[126815]} mt="16" mb="8" onClick={onClose} />
                        </Stack>
                        <VerticalContentsHandler contents={props.config.contents} />
                    </Stack>
                </Container>
            </FullScreenSheet>
            {isInfoOverlayVisible && <FooterComponent variant={FooterVariant.SeeOptionOnly} />}
        </>
    );
};

InfoOverlayContents.displayName = 'InfoOverlayContents';
